<div class="crm-page">
  <div class="crm-container">
    <!-- TOP BAR -->
    <header class="crm-top">
      <div class="brand">
        <div class="hero-logo">
          <img src="../../assets/images/Logo.svg" alt="Nishwik Logo" class="img-fluid" />
        </div>
        <span class="module-chip"><i class="fas fa-handshake"></i> CRM</span>
      </div>
      <div class="top-link">
        <a routerLink="/login"><i class="fas fa-arrow-left"></i> Back to sign in</a>
      </div>
    </header>

    <main class="crm-main">
      <!-- SHOWCASE -->
      <section class="showcase">
        <h1 class="headline">Your password has expired. Set a new one to continue.</h1>
        <p class="lede">
          Passwords are renewed regularly to keep customer and deal data safe.
          Choose a new one and you will go straight back to your pipeline.
        </p>

        <div class="shield-card">
          <div class="shield-visual" aria-hidden="true">
            <span class="ring ring-1"></span>
            <span class="ring ring-2"></span>
            <span class="shield-core"><i class="fas fa-shield-alt"></i></span>
          </div>
          <div class="shield-text">
            <strong>Your data stays protected</strong>
            <span>Customer records, notes and deal values are encrypted and visible only to your team.</span>
          </div>
        </div>

        <ul class="tips">
          <li><i class="fas fa-check"></i> Use 10 or more characters for a strong password</li>
          <li><i class="fas fa-check"></i> Mix letters, numbers and symbols</li>
          <li><i class="fas fa-check"></i> Avoid names, mobile numbers and old passwords</li>
        </ul>
      </section>

      <!-- FORM -->
      <section class="auth-side">
        <div class="auth-card">
          <div class="card-inner">
            <h2 class="card-title">Set a new password</h2>
            <p class="card-subtitle">Choose a strong password to protect your CRM account.</p>

            <form>
              <div class="input-group">
                <label for="new-password">New password <span class="req">*</span></label>
                <div class="input-wrap">
                  <i class="fas fa-lock input-icon"></i>
                  <input
                    type="password"
                    id="new-password"
                    name="newPassword"
                    [(ngModel)]="newPassword"
                    #newPass="ngModel"
                    placeholder="Min. 6 characters"
                    autocomplete="new-password"
                    required
                    minlength="6"
                  />
                </div>
                <div class="field-error" *ngIf="newPass.invalid && newPass.touched">
                  <span *ngIf="newPass.errors?.['required']">
                    <i class="fas fa-exclamation-circle"></i> Enter a new password.
                  </span>
                  <span *ngIf="newPass.errors?.['minlength']">
                    <i class="fas fa-exclamation-circle"></i> Use at least 6 characters.
                  </span>
                </div>
              </div>

              <!-- Strength meter -->
              <div class="password-hint" *ngIf="newPassword">
                <div class="hint-bar">
                  <div
                    class="hint-fill"
                    [style.width]="newPassword.length >= 10 ? '100%' : newPassword.length >= 6 ? '60%' : '25%'"
                    [class.weak]="newPassword.length < 6"
                    [class.fair]="newPassword.length >= 6 && newPassword.length < 10"
                    [class.strong]="newPassword.length >= 10"
                  ></div>
                </div>
                <span
                  class="hint-label"
                  [class.weak]="newPassword.length < 6"
                  [class.fair]="newPassword.length >= 6 && newPassword.length < 10"
                  [class.strong]="newPassword.length >= 10"
                >
                  {{ newPassword.length < 6 ? 'Weak' : newPassword.length < 10 ? 'Fair' : 'Strong' }}
                </span>
              </div>

              <div class="input-group">
                <label for="confirm-password">Confirm password <span class="req">*</span></label>
                <div class="input-wrap">
                  <i class="fas fa-check-circle input-icon"></i>
                  <input
                    type="password"
                    id="confirm-password"
                    name="confirmPassword"
                    [(ngModel)]="confirmPassword"
                    #confirmPass="ngModel"
                    placeholder="Re-enter new password"
                    autocomplete="new-password"
                    required
                  />
                </div>
                <div class="field-error" *ngIf="confirmPass.touched && confirmPass.errors?.['required']">
                  <i class="fas fa-exclamation-circle"></i> Confirm your new password.
                </div>
                <div class="field-error" *ngIf="confirmPass.touched && confirmPassword && confirmPassword !== newPassword">
                  <i class="fas fa-exclamation-circle"></i> Passwords do not match.
                </div>
              </div>

              <button
                type="button"
                class="btn-submit"
                [disabled]="!newPassword || !confirmPassword || newPassword !== confirmPassword"
                (click)="updatePassword()"
              >
                <span>Update password</span>
              </button>
            </form>

            <div class="card-footer-links">
              <a routerLink="/login" class="back-link">Back to sign in</a>
              <a (click)="redirectToSignUp()" class="signup-link">
                New here? <strong>Create account</strong>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footer class="bottom-bar">
      <p>&copy; 2026 Nishwik CRM. All rights reserved.</p>
      <div class="bottom-links">
        <a routerLink="/policy/privacy">Privacy Policy</a>
        <a routerLink="/policy/terms">Terms &amp; Conditions</a>
        <a routerLink="/policy/contact">Contact us</a>
      </div>
    </footer>
  </div>
</div>
